<template>
  <div>
    <b-card no-body>
      <b-card-header>
          <h3 class="float-left"><i class='fa fa-list'></i> Rule List</h3>
          <b-button variant="primary" class="float-right" @click="showCreateModal">Create Rule List</b-button>
      </b-card-header>
      <b-card-body>
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
          <template v-slot:cell(action)="data">
            <b-button variant="warning" @click="showEditModal(data.item.Id)">Edit</b-button>
          </template>
        </b-table>
        <nav>
          <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card-body>
    </b-card>
    <!-- <b-modal ref="createRuleList" size="lg" header-bg-variant="primary" hide-footer title="Create Rule List">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!($v.cRuleListName.$error)">
                      <label for="cRuleListName">Name</label>
                      <b-form-input type="text" id="cRuleListName" placeholder="Name" v-model="cRuleListName" :state="$v.cRuleListName.$error?false:null" @focus.native="$v.cRuleListName.$touch"></b-form-input>
                      <div v-if="$v.cRuleListName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.cRuleListName.required">Name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cRuleListName.minLength">Must have at least {{ $v.cRuleListName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cRuleListName.maxLength">Must not exceed {{ $v.cRuleListName.$params.maxLength.max}} letters</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="primary" @click="createRuleList" :disabled="$v.cRuleListName.$invalid">Create</b-btn>
          <b-btn class="mt-3" variant="outline-danger" @click="hideCreateModal">Cancel</b-btn>
    </b-modal> -->
    <b-modal ref="editRuleList" size="lg" header-bg-variant="primary" hide-footer title="Edit Rule List">
          <div class="d-block">
            <!-- <b-row>
              <b-col sm="12">
                <b-form-group :state="!($v.ruleId.$error)">
                  <b-row>
                    <b-col sm="8">
                      <label for="ruleId">Rule</label>
                      <b-form-select id="ruleId" :plain="false" v-model.trim="ruleId" :state="$v.ruleId.$error?false:null" @blur.native="$v.ruleId.$touch">
                        <option :value="null">Please select</option>
                        <option v-for="r in rules" :value="r.Id">{{ r.Name }}</option>
                      </b-form-select>
                      <div v-if="$v.ruleId.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.ruleId.required">Rule is required</div>
                      </div>
                    </b-col>
                    <b-col sm="4">
                      <label for="addRuleBtn">&nbsp;</label>
                      <div>
                        <b-btn id="addRuleBtn" variant="success" @click="addRule" :disabled="$v.ruleId.$invalid">
                          <i class="fa fa-plus-circle"></i> Add
                        </b-btn>
                      </div>
                    </b-col>
                  </b-row>
                </b-form-group>
              </b-col>
            </b-row> -->
            <b-row>
              <b-col sm="12">
                <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="listRules" :fields="listRulesFields" :current-page="rulesCurrentPage" :per-page="rulesPerPage">
                  <!-- <template v-slot:cell(action)="data">
                    <b-button variant="danger" @click="confirmRemoveRule(data.item.Id)">Remove</b-button>
                  </template> -->
                </b-table>
                <nav>
                  <b-pagination :total-rows="getRowCount(listRules)" :per-page="rulesPerPage" v-model="rulesCurrentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                </nav>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="outline-danger" @click="hideEditModal">Cancel</b-btn>
    </b-modal>
    <!-- <b-modal ref="confirm" size="sm" centered header-bg-variant="primary" hide-footer title="Remove This Rule">
          <div class="mb-3">
            Are you sure?
          </div>
          <b-button variant="success" @click="removeRule">Yes</b-button>
          <b-button variant="outline-danger" @click="cancelRemove">Cancel</b-button>
    </b-modal> -->
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  const {required, minLength, maxLength} = require('vuelidate/lib/validators')
  export default {
    name: 'rule-list-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        listRules: [],
        rules: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Name', label: 'Name'},
          {key: 'action', label: 'Action'}
        ],
        listRulesFields: [
          {key: 'Id', label: 'ID'},
          {key: 'RuleId', label: 'Rule ID'},
          {key: 'Name', label: 'Name'}
          // {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        perPage: 10,
        rulesCurrentPage: 1,
        rulesPerPage: 5,
        removeId: '',
        ruleId: '',
        cRuleListName: '',
        selectedRuleListId: ''
      }
    },
    validations: {
      ruleId: { required },
      cRuleListName: { required, minLength: minLength(2), maxLength: maxLength(50) }
    },
    watch: {
      currentPage: function () {
        this.getRuleList()
      },
      rulesCurrentPage: function () {
        this.getListRules()
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      getRuleLists () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/rule/list/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.list
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getListRules () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/rule/list/rules', {'id': this.selectedRuleListId}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.listRules = response.data.rules
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getAllRules () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/rule/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.rules = response.data.rules
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      createRuleList () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/rule/list/create', {'name': this.cRuleListName}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getRuleLists()
            this.hideCreateModal()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Rule List Created')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      addRule () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/rule/list/add', {'listId': this.selectedRuleListId, 'ruleId': this.ruleId}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getListRules()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Rule Added')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      removeRule () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/rule/list/remove', {'id': this.removeId}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getListRules()
            this.cancelRemove()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Rule Removed')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      confirmRemoveRule (id) {
        this.removeId = id
        this.$refs.confirm.show()
      },
      cancelRemove () {
        this.$refs.confirm.hide()
        this.showEditModal(this.selectedRuleListId)
      },
      showCreateModal () {
        this.reset()
        this.$refs.createRuleList.show()
      },
      showEditModal (id) {
        this.selectedRuleListId = id
        this.reset()
        this.getListRules()
        this.$refs.editRuleList.show()
      },
      hideCreateModal () {
        this.$refs.createRuleList.hide()
      },
      hideEditModal () {
        this.$refs.editRuleList.hide()
      },
      reset () {
        this.ruleId = ''
        this.cRuleListName = ''
      }
    },
    created () {
      this.getAllRules()
      this.getRuleLists()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/rulelist/RuleListTable.vue